import { signInWithPopup, User, FacebookAuthProvider } from 'firebase/auth';
import { auth } from '../config/firebase';

export interface FacebookAuthResponse {
  user: User;
  accessToken?: string;
  idToken?: string;
}

export const signInWithFacebook = async (): Promise<FacebookAuthResponse> => {
  const provider = new FacebookAuthProvider();
  provider.addScope('email',);
  // Request these fields (public_profile is default)
  provider.setCustomParameters({
    display: 'popup',
  });

  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const accessToken = FacebookAuthProvider.credentialFromResult(result)?.accessToken || undefined;

    // Get Firebase ID token for backend if needed
    const idToken = await user.getIdToken();

    return {
      user,
      accessToken,
      idToken,
    };
  } catch (error: any) {
    console.error('Facebook sign-in error:', error);
    if (error.code === 'auth/account-exists-with-different-credential') {
      throw new Error('An account already exists with the same email address but different sign-in credentials.');
    }
    throw new Error(error.message || 'Failed to sign in with Facebook');
  }
};

export const signOutFacebook = async (): Promise<void> => {
  // For Facebook, sign out is the same as Firebase signOut
  const { signOut } = await import('firebase/auth');
  await signOut(auth);
}; 